import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Lock, ShieldCheck, Mail } from 'lucide-react';

const COLS = [
  { title: 'Product', links: [
    ['Home', '/'], ['Pricing', '/pricing'], ['Shop NFC gear', '/shop'], ['Tapn.vip Pay', '/pay'],
    ['Contract-Ready Academy', '/for/academy'], ['Community', '/community'], ['Events & check-in', '/events/discover'],
    ['Digital Vault', '/vault-plans'], ['Emergency Health ID', '/for/health'], ['Free NFC Writer', '/free-nfc-writer'],
    ['Guides & Blog', '/blog'],
  ] },
  { title: 'Support', links: [
    ['About us', '/about'], ['Press', '/press'], ['Contact & help', '/support'], ['Help & FAQ', '/support#faq'],
    ['Trust Center', '/trust'], ['Install the app', '/install'], ['Site map', '/sitemap'],
  ] },
  { title: 'Legal', links: [
    ['Privacy Policy', '/privacy'], ['Terms of Service', '/terms'], ['Refund Policy', '/refund-policy'],
    ['Disclaimers', '/disclaimers'], ['Cookie Policy', '/cookie-policy'], ['Accessibility', '/accessibility'], ['DMCA', '/dmca'],
  ] },
];

export const SiteFooter = () => (
  <footer className="py-14 bg-slate-900 border-t border-white/10" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/tapn-logo.jpg" alt="Tapn.vip" loading="lazy" width="96" height="40" className="h-10 w-auto rounded-lg" />
            <div>
              <div className="text-white font-bold">Tapn.vip<sup className="text-[9px]">®</sup></div>
              <div className="text-amber-400 text-xs">VIP Network Digital Sharing</div>
            </div>
          </div>
          <p className="text-sm text-gray-400 max-w-sm mb-5" data-testid="footer-tagline">
            The tap that shares your card, trains your business, protects your documents and gets you paid — built in Milwaukee by Glossy Byrd Management LLC.
          </p>
          <div className="flex flex-wrap gap-2" data-testid="footer-trust-badges">
            <span className="inline-flex items-center gap-1.5 text-xs text-gray-300 border border-white/15 rounded-full px-3 py-1.5"><ShieldCheck className="w-3.5 h-3.5 text-emerald-400" /> Payments secured by Stripe</span>
            <span className="inline-flex items-center gap-1.5 text-xs text-gray-300 border border-white/15 rounded-full px-3 py-1.5"><Lock className="w-3.5 h-3.5 text-amber-400" /> 256-bit TLS encrypted</span>
          </div>
          <a href="mailto:Welcome@tapnvip.com" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-amber-400 mt-5" data-testid="footer-email">
            <Mail className="w-4 h-4" /> Welcome@tapnvip.com
          </a>
          <div className="flex gap-4 mt-5" data-testid="landing-social-links">
            <a href="https://www.facebook.com/share/1GV4agYCCT/" target="_blank" rel="noopener noreferrer" aria-label="Tapn.vip on Facebook" className="text-gray-400 hover:text-amber-400" data-testid="landing-social-facebook"><Facebook className="w-5 h-5" /></a>
            <a href="https://www.instagram.com/tapnvip" target="_blank" rel="noopener noreferrer" aria-label="Tapn.vip on Instagram" className="text-gray-400 hover:text-amber-400" data-testid="landing-social-instagram"><Instagram className="w-5 h-5" /></a>
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-gray-400 mb-4">{c.title}</h3>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={to}><Link to={to} className="text-sm text-gray-300 hover:text-amber-400" data-testid={`footer-link-${to.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'home'}`}>{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-10 pt-6 border-t border-white/10 text-center text-gray-500 text-xs">
        © 2026 Tapn.vip® · Glossy Byrd Management LLC · All rights reserved. The Future of Networking.
      </div>
    </div>
  </footer>
);
